export { diffToPatches } from "@json-render/core";
